import React from 'react';

import Documents from '@components/card/card-info-with-functionality/functionality/documents/Documents';
import Reorder from '@components/card/card-info-with-functionality/functionality/reorder/Reorder';
import Transactions from '@components/card/card-info-with-functionality/functionality/transactions/Transactions';
import { Card } from '@generated-types';

import BlockReplace from './block-replace/BlockReplace';
import CardControl from './card-control/CardControl';
import CardDetails from './card-details/CardDetails';
import Complaint from './complaint/Complaint';
import InsuranceProof from './insurance-proof/InsuranceProof';

interface FunctionalityProps {
    card: Card;
}

const Functionality = ({ card }: FunctionalityProps) => (
    <div>
        <Transactions card={card} />
        <CardDetails card={card} />
        <CardControl card={card} />
        <BlockReplace card={card} />
        <Reorder />
        <Documents card={card} />
        <InsuranceProof card={card} />
        <Complaint />
    </div>
);

export default Functionality;
